import { di } from 'react-magnetic-di';
import { useProvider } from '@atlassian/unified-help-common/src/store/routing';
import { ConversationProvider } from '@atlassian/unified-help-common/src/types';
import { useIsLastAssistantMessageGenerated } from '../../../store/converse';

export const useIsGenerating = () => {
    di(useProvider, useIsLastAssistantMessageGenerated);

    const provider = useProvider();
    const [isLastAssistantMessageGenerated] = useIsLastAssistantMessageGenerated();

    if (!provider || provider === ConversationProvider.VIRTUAL_AGENT) {
        return false;
    }

    return !isLastAssistantMessageGenerated;
};
